import type { ReactNode } from 'react'
import { View } from 'react-native'

import { Button } from '@/src/elements/button/default'
import { useMeQuery } from '@/src/features/auth/services/useMeQuery'
import { useWizardStore } from '@/src/features/settings/stores/useWizardStore'
import { useTopicsTagsQuery } from '@/src/features/tag/services/useTopicsTagsQuery'
import { ErrorMessage } from '@/src/general/components/ErrorMessage'
import { TEST_ID } from '@/src/general/constants/testId'
import { useDimensions } from '@/src/general/hooks/useDimensions'
import { useTranslate } from '@/src/lang/useTranslate'

import { WizardContentLayout } from '../../layouts/WizardContentLayout'
import { TagsButtonPlaceholders } from './TagsButtonPlaceholders'

export const TopicsStep = (): ReactNode => {
  const { t } = useTranslate()
  const toggleTag = useWizardStore((state) => state.toggleTag)
  const tags = useWizardStore((state) => state.tags)
  const { data: me } = useMeQuery()
  const { isLoading, error, data: topicTags } = useTopicsTagsQuery({ enabled: !!me?.lang })
  const { lessThan } = useDimensions()

  return (
    <WizardContentLayout title={t('user.wizard.what-topics')} testID={TEST_ID.ME.WIZARD.TOPICS}>
      <View className="flex h-full w-full flex-row flex-wrap justify-center gap-3">
        {!topicTags && error && <ErrorMessage error={error} defaultErrorKey="common.error.unknown" />}
        {!topicTags && isLoading && <TagsButtonPlaceholders />}
        {topicTags?.map(({ id, name, emoji }) => (
          <Button
            key={id}
            testID={TEST_ID.ME.WIZARD.TOPICS_TAG_BTN}
            variant={tags.includes(id) ? 'solid' : 'faded'}
            colors="primary"
            onPress={() => toggleTag(id)}
            size={lessThan.xm ? 'sm' : 'md'}
          >
            {emoji && `${emoji} `}
            {name}
          </Button>
        ))}
      </View>
    </WizardContentLayout>
  )
}
